"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetLibraryDesigner = WidgetLibraryDesigner;
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const widgets_1 = require("../widgets/widgets");
const expressions_1 = require("@mwater/expressions");
const WidgetDesigner_1 = __importDefault(require("./WidgetDesigner"));
const immer_1 = __importDefault(require("immer"));
const lodash_1 = __importDefault(require("lodash"));
const NewTab_1 = require("./NewTab");
/** Design mode for a library of widgets */
function WidgetLibraryDesigner(props) {
    const [activeTabIndex, setActiveTabIndex] = (0, react_1.useState)(0);
    // Schema that has deprecated columns removed
    const noDeprecatedSchema = (0, react_1.useMemo)(() => {
        const schema = props.baseCtx.schema;
        // Remove deprecated columns
        const newSchema = new expressions_1.Schema((0, immer_1.default)(schema.toJSON(), (draft) => {
            for (const table of draft.tables) {
                table.contents = (0, expressions_1.flattenContents)(table.contents).filter((content) => !content.deprecated);
            }
            // Remove deprecated tables
            draft.tables = draft.tables.filter((table) => !table.deprecated);
        }));
        return newSchema;
    }, [props.baseCtx.schema]);
    // Widget library that has deprecated widgets removed
    const noDeprecatedWidgetLibrary = (0, react_1.useMemo)(() => {
        return (0, immer_1.default)(props.baseCtx.widgetLibrary, (draft) => {
            Object.keys(draft.widgets).forEach((key) => {
                if (draft.widgets[key].deprecated) {
                    delete draft.widgets[key];
                }
            });
        });
    }, [props.baseCtx.widgetLibrary]);
    /** Validate a single widget
     *
     * @param noDeprecated if true, will not allow deprecated columns or tables or widgets
     */
    const validateSingleWidget = (0, react_1.useCallback)((widgetDef, noDeprecated) => {
        if (noDeprecated) {
            return (0, widgets_1.validateWidget)(widgetDef, { ...props.baseCtx, schema: noDeprecatedSchema, widgetLibrary: noDeprecatedWidgetLibrary }, true);
        }
        return (0, widgets_1.validateWidget)(widgetDef, props.baseCtx, true);
    }, [props.baseCtx.widgetLibrary, props.baseCtx.schema, noDeprecatedSchema, noDeprecatedWidgetLibrary]);
    const handleTabChange = (0, react_1.useCallback)((widgetId, widgetDef) => {
        props.onWidgetLibraryChange((0, immer_1.default)(props.baseCtx.widgetLibrary, (draft) => {
            draft.widgets[widgetId] = widgetDef;
        }));
    }, [props]);
    const handleSelectTab = (0, react_1.useCallback)((index) => {
        setActiveTabIndex(index);
    }, []);
    const handleAddWidget = (0, react_1.useCallback)((widgetDef) => {
        const widgetLibrary = (0, immer_1.default)(props.baseCtx.widgetLibrary, (draft) => {
            draft.widgets[widgetDef.id] = widgetDef;
        });
        props.onWidgetLibraryChange(widgetLibrary);
        props.onOpenTabsChange(props.openTabs.concat(widgetDef.id));
    }, [props]);
    const handleDuplicateWidget = (0, react_1.useCallback)((widgetDef) => {
        const newId = (0, uuid_1.v4)();
        const widgetLibrary = (0, immer_1.default)(props.baseCtx.widgetLibrary, (draft) => {
            const newDef = lodash_1.default.cloneDeep(widgetDef);
            newDef.id = newId;
            newDef.name = newDef.name + " (duplicate)";
            newDef.description = newDef.description;
            newDef.group = newDef.group;
            draft.widgets[newId] = newDef;
        });
        props.onWidgetLibraryChange(widgetLibrary);
    }, [props]);
    const handleCloseTab = (0, react_1.useCallback)((index, ev) => {
        ev.stopPropagation();
        const openTabs = props.openTabs.slice();
        openTabs.splice(index, 1);
        props.onOpenTabsChange(openTabs);
    }, [props]);
    const handleOpenWidget = (0, react_1.useCallback)((widgetId) => {
        props.onOpenTabsChange(props.openTabs.concat(widgetId));
    }, [props]);
    const handleRemoveWidget = (0, react_1.useCallback)((widgetId) => {
        const widget = props.baseCtx.widgetLibrary.widgets[widgetId];
        if (!confirm(`Permanently delete ${widget.name} widget?`)) {
            return;
        }
        const widgetLibrary = (0, immer_1.default)(props.baseCtx.widgetLibrary, (draft) => {
            delete draft.widgets[widgetId];
        });
        props.onOpenTabsChange(lodash_1.default.without(props.openTabs, widgetId));
        props.onWidgetLibraryChange(widgetLibrary);
    }, [props]);
    const renderTab = (0, react_1.useCallback)((index) => {
        const activeTabId = props.openTabs[index];
        const widgetDef = props.baseCtx.widgetLibrary.widgets[activeTabId];
        // For immediately deleted tabs
        if (!widgetDef) {
            return null;
        }
        return (react_1.default.createElement("li", { className: "nav-item", key: index },
            react_1.default.createElement("a", { className: index === activeTabIndex ? "nav-link active" : "nav-link", onClick: () => handleSelectTab(index) },
                widgetDef.name,
                "\u00A0",
                react_1.default.createElement("i", { onClick: (ev) => handleCloseTab(index, ev), className: "fa fa-remove text-muted" }))));
    }, [activeTabIndex, handleSelectTab, handleCloseTab, props]);
    const renderActiveTabContents = (0, react_1.useCallback)(() => {
        if (activeTabIndex < props.openTabs.length) {
            const activeTabId = props.openTabs[activeTabIndex];
            const widgetDef = props.baseCtx.widgetLibrary.widgets[activeTabId];
            // For immediately deleted tabs
            if (!widgetDef) {
                return null;
            }
            return (react_1.default.createElement(WidgetDesigner_1.default, { key: widgetDef.id, widgetDef: widgetDef, baseCtx: props.baseCtx, dataSource: props.dataSource, blockPaletteEntries: props.blockPaletteEntries, onWidgetDefChange: (widgetDef) => handleTabChange(activeTabId, widgetDef), globalContextVarPreviewValues: props.globalContextVarPreviewValues }));
        }
        else {
            return (react_1.default.createElement(NewTab_1.NewTab, { widgetLibrary: props.baseCtx.widgetLibrary, onAddWidget: handleAddWidget, onOpenWidget: handleOpenWidget, onRemoveWidget: handleRemoveWidget, onDuplicateWidget: handleDuplicateWidget, validateWidget: validateSingleWidget }));
        }
    }, [activeTabIndex, handleAddWidget, handleDuplicateWidget, handleOpenWidget, handleRemoveWidget, handleTabChange, props, validateSingleWidget]);
    return (react_1.default.createElement("div", { style: { height: "100%", display: "grid", gridTemplateRows: "auto 1fr" } },
        react_1.default.createElement("ul", { className: "nav nav-tabs", style: { marginBottom: 5 } },
            props.openTabs.map((tab, index) => renderTab(index)),
            react_1.default.createElement("li", { className: "nav-item", key: "new" },
                react_1.default.createElement("a", { className: activeTabIndex >= props.openTabs.length ? "nav-link active" : "nav-link", onClick: () => handleSelectTab(props.openTabs.length) },
                    react_1.default.createElement("i", { className: "fa fa-plus" })))),
        renderActiveTabContents()));
}
